import anthropicLogoSrc from "./assets/compatibility-logos/claude.webp";
import copilot365LogoSrc from "./assets/compatibility-logos/copilot-365.webp";
import geminiLogoSrc from "./assets/compatibility-logos/gemini.webp";
import copilotLogoSrc from "./assets/compatibility-logos/github-copilot.svg";
import hermesLogoSrc from "./assets/compatibility-logos/hermes-agent.png";
import { skillCompatibilityTitle } from "./skillCompatibility";

const LOGO_ASSETS: Record<string, { title: string; src: string }> = {
  "GitHub Copilot": { title: "GitHub Copilot", src: copilotLogoSrc },
  "Copilot 365": { title: "Copilot 365", src: copilot365LogoSrc },
  "Copilot Cowork": { title: "Copilot Cowork", src: copilot365LogoSrc },
  "Google Gemini": { title: "Google Gemini", src: geminiLogoSrc },
  Anthropic: { title: "Claude", src: anthropicLogoSrc },
  Hermes: { title: "Hermes", src: hermesLogoSrc },
};

/** Renders the brand logo (16×16) for a compatible harness value. */
export function SkillCompatibilityBrandIcon({
  value,
  className,
  size = 16,
}: {
  value: string;
  className?: string;
  size?: number;
}) {
  const logo =
    LOGO_ASSETS[skillCompatibilityTitle(value)] ?? LOGO_ASSETS.Hermes!;
  return (
    <img
      className={className}
      src={logo.src}
      alt={logo.title}
      title={logo.title}
      width={size}
      height={size}
    />
  );
}
